'use client';

config.autoAddCss = false;
import { ReactNode, useEffect, useMemo, useState } from 'react';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import './../common/style/globals.css';
import useFaviconStore from '../common/zustand/useFaviconStore';
import { ClerkProvider } from '@clerk/nextjs';
import { notFound, redirect, usePathname } from 'next/navigation';
import { getCustomUrls, getOfferSlugAndHostname } from '../common/js/utils';

export interface CustomUrlsProps {
  not_found_redirect_url: string | null;
  root_redirect_url: string | null;
}

export default function DashboardLayout({ children }: { children: ReactNode }) {
  const { faviconUrl } = useFaviconStore();
  const pathname = usePathname();
  const [hostname, setHostname] = useState('');
  const { offerSlugExists, resolvedHostname } = useMemo(
    () => getOfferSlugAndHostname(pathname, hostname),
    [pathname, hostname]
  );
  const [customUrls, setCustomUrls] = useState<CustomUrlsProps | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHostname(window.location.hostname);
    }
  }, []);

  useEffect(() => {
    if (!resolvedHostname) return;
    try {
      getCustomUrls(resolvedHostname).then(setCustomUrls);
    } catch (error) {
      notFound();
    }
  }, [resolvedHostname]);

  if (
    !offerSlugExists &&
    (customUrls?.root_redirect_url || customUrls?.not_found_redirect_url)
  ) {
    redirect(
      (customUrls.root_redirect_url ?? customUrls.not_found_redirect_url)!
    );
  }

  const clerkConfig = {
    appearance: {
      elements: {
        footer: 'hidden',
      },
    },
    localization: {
      signIn: {
        start: {
          title: 'Sign in to continue',
          subtitle: '',
        },
      },
    },
  };

  return (
    <html className="w-full h-full p-0 m-0 bg-[#F3F4F6]">
      <head>
        <link rel="icon" href={faviconUrl} />
        <title></title>
      </head>
      <body className="w-full h-full p-0 m-0">
        <div className={`bg-[#F3F4F6] h-screen flex justify-between flex-col`}>
          <ClerkProvider {...clerkConfig}>{children}</ClerkProvider>
        </div>
      </body>
    </html>
  );
}
